'use client';

import { Box, HStack, Button, Text, Input } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import { FaBoxOpen } from "react-icons/fa";
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { BoxTitle } from '@/components/BoxTitle';
import CustomTable from '../../components/CustomTable';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete?: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaFabricanteVeiculo({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newFabricante, setNewFabricante] = useState('');

  // Estados para o ModalRetorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  // Função para atualizar os dados após a exclusão
  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    if (onDelete) {
      onDelete(selectedData);
    }
    setMensagemRetorno("Fabricante excluído com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  const handleAddTipoCarga = () => {
    if (newFabricante.trim() !== '') {
      setTableData(prev => [
        ...prev,
        { id: prev.length + 1, fabricante: newFabricante, ativo: true },
      ]);
      setNewFabricante('');
      setIsModalOpen(false);
      setMensagemRetorno("Fabricante adicionado com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Text fontSize="lg" ml={2}>Adicionar Novo Fabricante</Text>}
        body={
          <Box mt={3}>
            <BoxTitle title="Fabricante">
              <Input
                placeholder="Adicione um Fabricante"
                value={newFabricante}
                onChange={(e) => setNewFabricante(e.target.value)}
              />
            </BoxTitle>
          </Box>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAddTipoCarga}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
